import { render, staticRenderFns } from "./monthly-attendances.vue?vue&type=template&id=345a4e5c&"
import script from "./monthly-attendances.vue?vue&type=script&lang=js&"
export * from "./monthly-attendances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports